export default __webpack_public_path__ + "static/media/troy.3f3f5de2.svg";